export default __webpack_public_path__ + "static/media/adelaideHover.3ccb5620.svg";